import { render, staticRenderFns } from "./WarehouseSplitPopup.vue?vue&type=template&id=9c6b9cfe&scoped=true"
import script from "./WarehouseSplitPopup.vue?vue&type=script&lang=js"
export * from "./WarehouseSplitPopup.vue?vue&type=script&lang=js"
import style0 from "./WarehouseSplitPopup.vue?vue&type=style&index=0&id=9c6b9cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6b9cfe",
  null
  
)

export default component.exports